/**
 * Diacritic- and case-insensitive substring matching for as-you-type search
 * over catalog rows (QA #7 / WMS-8). Lithuanian diacritics are folded so
 * "edziu" matches "edziu" spelled with diacritics and "suol" matches "Suolas".
 * Multiple whitespace-separated terms are ANDed.
 */
export function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

export function matchesQuery(
  query: string,
  ...fields: (string | null | undefined)[]
): boolean {
  const q = normalize(query.trim());
  if (!q) return true;
  const hay = normalize(fields.filter(Boolean).join(' '));
  return q.split(/\s+/).every((term) => hay.includes(term));
}
